/* Tekstlaag in de zoom-weergave van de PDP-galerij (founder 2026-07-03).
   Het thema bouwt de vergrote foto als losse <img> in de gallery-viewer-modal
   (main.js). Dit script kijkt mee: zodra zo'n zoom-foto verschijnt, kloont het
   de vm-gt-tekstlaag van de bijbehorende dia (gekoppeld via data-media-id) en
   laat die exact meebewegen met pannen en zoomen door top/left/transform van
   de foto te spiegelen. Raakt main.js zelf niet aan. */
(function () {
  'use strict';

  function koppelOverlay(img) {
    var viewer = img.closest('gallery-viewer');
    if (!viewer) return;
    var actieveThumb = viewer.querySelector('.gallery-viewer__thumb--active');
    if (!actieveThumb || !actieveThumb.dataset.mediaId) return;
    var dia = '.media-gallery .main-image .slider__item[data-media-id="' + actieveThumb.dataset.mediaId + '"] ';
    var bronnen = document.querySelectorAll(dia + '.vm-gt, ' + dia + '.vm-trustbadges, ' + dia + '.vm-vervangt');
    if (!bronnen.length) return;

    var wrap = document.createElement('div');
    wrap.className = 'vm-gt-zoomwrap';
    bronnen.forEach(function (b) { wrap.appendChild(b.cloneNode(true)); });

    function maatEnPositie() {
      wrap.style.width = img.clientWidth + 'px';
      wrap.style.height = img.clientHeight + 'px';
      wrap.style.top = img.style.top;
      wrap.style.left = img.style.left;
      wrap.style.transform = img.style.transform;
      wrap.style.visibility = img.style.visibility;
    }

    if (img.complete && img.clientWidth > 0) {
      maatEnPositie();
    } else {
      img.addEventListener('load', maatEnPositie, { once: true });
    }

    new MutationObserver(maatEnPositie).observe(img, { attributes: true, attributeFilter: ['style'] });
    img.insertAdjacentElement('afterend', wrap);
  }

  new MutationObserver(function (mutaties) {
    mutaties.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.classList && node.classList.contains('gallery-viewer__zoom-image')) {
          koppelOverlay(node);
        } else if (node.querySelector) {
          var img = node.querySelector('.gallery-viewer__zoom-image');
          if (img) koppelOverlay(img);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
